// WHIT-493: icon pictures that carry brand colours in the file itself. The
// Allmyles copies (assets/svgs/allmyles) are the same drawings with the
// Tipptour colours swapped for the Allmyles values of the same tokens
// (tt-dark-purple, tt-yellow, tt-light-purple, tt-verydark-purple; HANDOFF.md
// section 2). Tipptour keeps the original files.
import { IS_ALLMYLES } from 'utils/brand';
import arrival from './arrival.svg';
import calendar from './calendar.svg';
import departure from './departure.svg';
import filter from './filter.svg';
import iconAirplane from './icon-airplane.svg';
import iconExit from './icon-exit.svg';
import iconRoad from './icon-road.svg';
import minus from './minus.svg';
import passengers from './passengers.svg';
import plus from './plus.svg';
import swap from './swap.svg';
import allmylesArrival from './allmyles/arrival.svg';
import allmylesCalendar from './allmyles/calendar.svg';
import allmylesDeparture from './allmyles/departure.svg';
import allmylesFilter from './allmyles/filter.svg';
import allmylesIconAirplane from './allmyles/icon-airplane.svg';
import allmylesIconExit from './allmyles/icon-exit.svg';
import allmylesIconRoad from './allmyles/icon-road.svg';
import allmylesMinus from './allmyles/minus.svg';
import allmylesPassengers from './allmyles/passengers.svg';
import allmylesPlus from './allmyles/plus.svg';
import allmylesSwap from './allmyles/swap.svg';

export const arrivalIcon = IS_ALLMYLES ? allmylesArrival : arrival;
export const calendarIcon = IS_ALLMYLES ? allmylesCalendar : calendar;
export const departureIcon = IS_ALLMYLES ? allmylesDeparture : departure;
export const filterIcon = IS_ALLMYLES ? allmylesFilter : filter;
export const airplaneIcon = IS_ALLMYLES ? allmylesIconAirplane : iconAirplane;
export const exitIcon = IS_ALLMYLES ? allmylesIconExit : iconExit;
export const roadIcon = IS_ALLMYLES ? allmylesIconRoad : iconRoad;
// Drawn for WHIT-493 in the set's style (no passenger icon existed).
export const passengersIcon = IS_ALLMYLES ? allmylesPassengers : passengers;
export const minusIcon = IS_ALLMYLES ? allmylesMinus : minus;
export const plusIcon = IS_ALLMYLES ? allmylesPlus : plus;
export const swapIcon = IS_ALLMYLES ? allmylesSwap : swap;
